import React from "react";
import { Capacity, ExplorationType, Perspective, UIState } from "../../../App";
import './PanelMenu.scoped.scss';

interface ComponentProps {
    onClickHandler: (newState: UIState) => void;
    uiState: UIState;
    explorationType: ExplorationType;
    onClickClose?: () => void;
    category?: Capacity;
    perspective?: Perspective;
}

interface ComponentState {
    hasInitialized: boolean;
    hasFinishedAnimating: boolean;
}

class PanelMenu extends React.Component<ComponentProps, ComponentState> {
    constructor(props: ComponentProps) {
        super(props);
        this.state = { hasInitialized: false, hasFinishedAnimating: false };
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ hasInitialized: true });
            setTimeout(() => {
                this.setState({ hasFinishedAnimating: true });
            }, 3200);
        }, 900);
    }

    private didClickOnExpendCapacities = () => {
        switch (this.props.explorationType) {
            case ExplorationType.Capacities:
                return this.props.onClickHandler(UIState.CapacitiesOpened);
            case ExplorationType.Perspectives:
                return this.props.onClickHandler(UIState.PerspectivesOpened);
        }
    }

    private didClickOnHomeButton = () => {
        this.props.onClickHandler(UIState.Intro);
    }

    private didClickOnCloseButton = () => {
        if (this.props.onClickClose) {
            this.props.onClickClose();
        }
    }

    private titleForExplorationType = () => {
        switch (this.props.explorationType) {
            case ExplorationType.Capacities:
                return <>Discover the <b>capacities</b></>
            case ExplorationType.Perspectives:
                return <>Explore the <b>perspectives</b></>
        }
    }

    private collapsedTitleForExplorationType = () => {
        switch (this.props.explorationType) {
            case ExplorationType.Capacities:
                return <><b>Core Capacities</b></>
            case ExplorationType.Perspectives:
                return <><b>Perspectives</b></>
        }
    }

    render() {
        let uiStateClass = (this.props.uiState !== UIState.Intro) ? "collapsed" : "";
        let isActivePerspective = (this.props.uiState === UIState.CapacitiesOpened && this.props.explorationType === ExplorationType.Capacities) ||
            (this.props.uiState === UIState.PerspectivesOpened && this.props.explorationType === ExplorationType.Perspectives)
        let isGeneralType = (this.props.category && this.props.category === Capacity.General) || (this.props.perspective && this.props.perspective === Perspective.General);
        let explorationTypeClass = (this.props.explorationType === ExplorationType.Perspectives) ? "perspectives" : "";
        let imageForExpend = this.props.explorationType === ExplorationType.Perspectives ? '/assets/smallExpendPerspectives.svg' : '/assets/smallExpendCapacities.svg';
        let hasInitialized = this.state.hasInitialized ? "" : "initialState";
        let introAnimationClass = this.state.hasFinishedAnimating ? "" : "introAnimation"

        return (
            <>
                <div className={['panel-menu-wrp', uiStateClass, explorationTypeClass, this.props.explorationType, isActivePerspective ? 'active' : '',
                    isGeneralType ? 'generalType' : 'sectionType', hasInitialized, introAnimationClass].join(' ')}>
                    <div className="panel-expended" onClick={this.didClickOnExpendCapacities}>
                        <div className="menu-open-wrp">
                            <img className="menu-open-icon" src="/assets/openPanelIcon.svg" alt="Open Menu Icon" />
                        </div>
                        <div className="menu-title">{this.titleForExplorationType()}</div>
                    </div>
                    <div className="panel-collapsed">
                        <div className="menu-homeButton" onClick={this.didClickOnHomeButton}>
                            <img src="/assets/navigationHomeButton.svg" alt="Home button" />
                        </div>
                        <div className="menu-closeButton" onClick={this.didClickOnCloseButton}>
                            <img src="/assets/navigationCloseButton.svg" alt="Close button" />
                        </div>
                        <div className="menu-title long">{this.titleForExplorationType()}</div>
                        <div className="menu-title">{this.collapsedTitleForExplorationType()}</div>
                        <div className="menu-expendButton" onClick={this.didClickOnExpendCapacities}>
                            <img src={imageForExpend} alt="Expend section icon" />
                        </div>
                    </div>
                </div>
                <div className={["panel-expended desktopHiddenElement bottomTablet", this.props.uiState, this.props.explorationType, isActivePerspective ? 'active' : ''].join(' ')} onClick={this.didClickOnExpendCapacities}>
                    <div className="menu-open-wrp">
                        <img className="menu-open-icon" src="/assets/openPanelIcon.svg" alt="Open Menu Icon" />
                    </div>
                    <div className="menu-title">{this.titleForExplorationType()}</div>
                </div>
            </>
        )
    }
}

export default PanelMenu;